export function OperationEntryTabSupport() {
  let url = location.href;
  let nav_page;
//   setTimeout(function () {
    if (url.indexOf("#") != -1) {
      switch (url.split("#")[1]) {
        case "nav1":
          let nav1Btn = document.querySelector(`#nav1`);
          nav1Btn.click();
          nav_page = 0;
          break;
        case "nav2":
          let nav2Btn = document.querySelector(`#nav2`);
          nav2Btn.click();
          nav_page = 1;
          break;
        case "nav3":
          let nav3Btn = document.querySelector(`#nav3`);
          nav3Btn.click();
          nav_page = 2;
          break;
        case "nav4":
          let nav4Btn = document.querySelector(`#nav4`);
          nav4Btn.click();
          nav_page = 3;
          break;
        case "nav5":
          let nav5Btn = document.querySelector(`#nav5`);
          nav5Btn.click();
          nav_page = 4;
          break;
      }
    }
    return nav_page;
//   }, 500);
}
